export enum I18nKey {
    ActivateSuccess = 'FEATURE_SCOPES.ACTIVATE_SUCCESS',
    DeactivateSuccess = 'FEATURE_SCOPES.DEACTIVATE_SUCCESS',
    ActivateConfirmation = 'FEATURE_SCOPES.ACTIVATE_CONFIRMATION',
    DeactivateConfirmation = 'FEATURE_SCOPES.DEACTIVATE_CONFIRMATION',
}
